(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-spline"] && !Shopify.designMode) return;
  try {
    
  // Exception to zero-dependency rule: Spline viewer is a merchant-configured
  // 3rd-party 3D scene embed, loaded on-demand via dynamic import.
  import('https://unpkg.com/@splinetool/viewer@1.12.70/build/spline-viewer.js');

  class SplineLoadingHandler extends HTMLElement {
    connectedCallback() {
      this.splineViewer = this.querySelector('spline-viewer');
      this.throbber = this.querySelector('.spline-throbber');

      if (!this.splineViewer) return;

      this.splineViewer.addEventListener('load-complete', () => this.fadeInSpline());
      setTimeout(() => this.fadeInSpline(), 5000);
    }

    fadeInSpline() {
      this.splineViewer.classList.add('spline-scene--loaded');
      if (this.throbber) {
        this.throbber.classList.add('spline-throbber--hidden');
      }
    }
  }

  customElements.define('spline-loading-handler', SplineLoadingHandler);

  class SpaceBackgroundCanvas extends HTMLElement {
    constructor() {
      super();
      this.canvas = null;
      this.gl = null;
      this.program = null;
      this.animationFrameId = null;
      this.startTime = null;
      this.uTimeLoc = null;
      this.resizeHandler = null;
      this.motionQuery = null;
      this.motionChangeHandler = null;
    }

    connectedCallback() {
      this.startTime = Date.now();
      this.#initCanvas();
      this.#initWebGL();

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionChangeHandler = () => this.#onMotionPreferenceChange();
      this.motionQuery.addEventListener('change', this.motionChangeHandler);

      if (this.motionQuery.matches) {
        this.#renderStaticFrame();
      } else {
        this.#render();
      }

      this.resizeHandler = () => this.#handleResize();
      window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
      if (this.motionQuery && this.motionChangeHandler) {
        this.motionQuery.removeEventListener('change', this.motionChangeHandler);
      }
    }

    #onMotionPreferenceChange() {
      if (this.motionQuery.matches) {
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
          this.animationFrameId = null;
        }
        this.#renderStaticFrame();
      } else {
        this.#render();
      }
    }

    #renderStaticFrame() {
      if (!this.gl) return;

      if (this.uTimeLoc !== null) {
        this.gl.uniform1f(this.uTimeLoc, 0);
      }

      this.gl.clear(this.gl.COLOR_BUFFER_BIT);
      this.gl.drawArrays(this.gl.TRIANGLE_STRIP, 0, 4);
    }

    #initCanvas() {
      const canvasId = this.getAttribute('canvas-id');
      this.canvas = document.createElement('canvas');
      this.canvas.id = canvasId;
      this.appendChild(this.canvas);
      this.#resizeCanvas();
    }

    #resizeCanvas() {
      const rect = this.getBoundingClientRect();
      this.canvas.width = rect.width * window.devicePixelRatio;
      this.canvas.height = rect.height * window.devicePixelRatio;

      if (this.gl) {
        this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
      }
    }

    #initWebGL() {
      this.gl = this.canvas.getContext('webgl') || this.canvas.getContext('experimental-webgl');

      if (!this.gl) {
        console.error('WebGL not supported');
        return;
      }

      const vertexShader = this.#createShader(this.gl.VERTEX_SHADER, this.#getVertexShaderSource());
      const fragmentShader = this.#createShader(this.gl.FRAGMENT_SHADER, this.#getFragmentShaderSource());

      this.program = this.gl.createProgram();
      this.gl.attachShader(this.program, vertexShader);
      this.gl.attachShader(this.program, fragmentShader);
      this.gl.linkProgram(this.program);

      if (!this.gl.getProgramParameter(this.program, this.gl.LINK_STATUS)) {
        console.error('Program link failed:', this.gl.getProgramInfoLog(this.program));
        return;
      }

      this.gl.useProgram(this.program);
      this.#setupBuffers();
      this.#setUniforms();
    }

    #createShader(type, source) {
      const shader = this.gl.createShader(type);
      this.gl.shaderSource(shader, source);
      this.gl.compileShader(shader);

      if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
        console.error('Shader compilation failed:', this.gl.getShaderInfoLog(shader));
        this.gl.deleteShader(shader);
        return null;
      }

      return shader;
    }

    #setupBuffers() {
      const vertices = new Float32Array([-1, -1, 0, 1, -1, 0, -1, 1, 0, 1, 1, 0]);

      const vertexBuffer = this.gl.createBuffer();
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, vertexBuffer);
      this.gl.bufferData(this.gl.ARRAY_BUFFER, vertices, this.gl.STATIC_DRAW);

      const positionAttrib = this.gl.getAttribLocation(this.program, 'position');
      this.gl.enableVertexAttribArray(positionAttrib);
      this.gl.vertexAttribPointer(positionAttrib, 3, this.gl.FLOAT, false, 0, 0);
    }

    #setUniforms() {
      const primaryColor = this.#hexToRgb(this.getAttribute('primary-color'));
      const secondaryColor = this.#hexToRgb(this.getAttribute('secondary-color'));
      const accentColor = this.#hexToRgb(this.getAttribute('accent-color'));

      const uPrimaryLoc = this.gl.getUniformLocation(this.program, 'uPrimaryColor');
      const uSecondaryLoc = this.gl.getUniformLocation(this.program, 'uSecondaryColor');
      const uAccentLoc = this.gl.getUniformLocation(this.program, 'uAccentColor');
      const uResolutionLoc = this.gl.getUniformLocation(this.program, 'uResolution');
      const uWarpStrength1Loc = this.gl.getUniformLocation(this.program, 'uWarpStrength1');
      const uWarpStrength2Loc = this.gl.getUniformLocation(this.program, 'uWarpStrength2');
      this.uTimeLoc = this.gl.getUniformLocation(this.program, 'uTime');

      const warpStrength1 = parseFloat(this.getAttribute('warp-strength-1')) || 2.5;
      const warpStrength2 = parseFloat(this.getAttribute('warp-strength-2')) || 3.0;

      this.gl.uniform3f(uPrimaryLoc, primaryColor.r / 255.0, primaryColor.g / 255.0, primaryColor.b / 255.0);
      this.gl.uniform3f(uSecondaryLoc, secondaryColor.r / 255.0, secondaryColor.g / 255.0, secondaryColor.b / 255.0);
      this.gl.uniform3f(uAccentLoc, accentColor.r / 255.0, accentColor.g / 255.0, accentColor.b / 255.0);
      this.gl.uniform2f(uResolutionLoc, this.canvas.width, this.canvas.height);
      this.gl.uniform1f(uWarpStrength1Loc, warpStrength1);
      this.gl.uniform1f(uWarpStrength2Loc, warpStrength2);
    }

    #hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : { r: 61, g: 79, b: 167 };
    }

    #render() {
      if (!this.gl) return;

      const elapsedTime = (Date.now() - this.startTime) / 1000;
      const animationSpeed = parseFloat(this.getAttribute('animation-speed')) || 0.5;

      if (this.uTimeLoc !== null) {
        this.gl.uniform1f(this.uTimeLoc, elapsedTime * animationSpeed);
      }

      this.gl.clear(this.gl.COLOR_BUFFER_BIT);
      this.gl.drawArrays(this.gl.TRIANGLE_STRIP, 0, 4);

      this.animationFrameId = requestAnimationFrame(() => this.#render());
    }

    #handleResize() {
      this.#resizeCanvas();
      if (this.gl && this.program) {
        this.gl.useProgram(this.program);
        const uResolutionLoc = this.gl.getUniformLocation(this.program, 'uResolution');
        this.gl.uniform2f(uResolutionLoc, this.canvas.width, this.canvas.height);
      }
    }

    #getVertexShaderSource() {
      return `
      attribute vec3 position;
      void main() {
        gl_Position = vec4(position, 1.0);
      }
    `;
    }

    #getFragmentShaderSource() {
      return `
      precision mediump float;
      uniform vec3 uPrimaryColor;
      uniform vec3 uSecondaryColor;
      uniform vec3 uAccentColor;
      uniform vec2 uResolution;
      uniform float uWarpStrength1;
      uniform float uWarpStrength2;
      uniform float uTime;

      // Hash-based noise
      float hash(vec2 p) {
        return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
      }

      // Smooth noise interpolation
      float noise(vec2 p) {
        vec2 i = floor(p);
        vec2 f = fract(p);
        f = f * f * (3.0 - 2.0 * f);

        float a = hash(i);
        float b = hash(i + vec2(1.0, 0.0));
        float c = hash(i + vec2(0.0, 1.0));
        float d = hash(i + vec2(1.0, 1.0));

        return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);
      }

      // FBM with smooth noise for cohesive patterns
      float fbm(vec2 p) {
        float value = 0.0;
        float amplitude = 0.5;
        float frequency = 1.0;
        float maxValue = 0.0;

        for (int i = 0; i < 2; i++) {
          value += amplitude * noise(p * frequency);
          maxValue += amplitude;
          amplitude *= 0.5;
          frequency *= 2.0;
        }

        return value / maxValue;
      }

      // Multi-level domain warping for flowing ribbon effect
      float domainWarpedPattern(vec2 p) {
        // Time-based offset for subtle morphing animation
        vec2 timeOffset = vec2(sin(uTime * 0.3) * 0.15, cos(uTime * 0.25) * 0.15);

        // First level domain warp
        vec2 q = vec2(
          fbm(p + vec2(0.0, 0.0) + timeOffset),
          fbm(p + vec2(5.2, 1.3) + timeOffset)
        );

        // Second level domain warp with configurable strength
        vec2 r = vec2(
          fbm(p + uWarpStrength1 * q + vec2(1.7, 9.2) + timeOffset * 0.5),
          fbm(p + uWarpStrength1 * q + vec2(8.3, 2.8) + timeOffset * 0.5)
        );

        // Final pattern with configurable warp strength
        float pattern = fbm(p + uWarpStrength2 * r + timeOffset * 0.25);

        return pattern;
      }

      void main() {
        vec2 uv = gl_FragCoord.xy / uResolution.xy;
        uv = uv * 2.0 - 1.0;
        uv.x *= uResolution.x / uResolution.y;

        // Scale coordinates for appropriate feature size
        vec2 p = uv * 2.5;

        // Get domain-warped pattern
        float pattern = domainWarpedPattern(p);

        // Posterize into 3 bands for large, bold color blocks
        float posterized = floor(pattern * 3.0) / 3.0;

        // Hard color boundaries for large, thick ribbons with visible magenta
        vec3 color;
        if (posterized < 0.333) {
          color = uPrimaryColor;
        } else if (posterized < 0.5) {
          color = uSecondaryColor;
        } else {
          color = uAccentColor;
        }

        gl_FragColor = vec4(color, 1.0);
      }
    `;
    }
  }

  customElements.define('space-background-canvas', SpaceBackgroundCanvas);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
